module.exports = __webpack_public_path__ + "static/media/profile.46a29829.jpg";